import React, { useEffect, useMemo } from 'react';
import { DynamicForm, PageFooter, PageHeader } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useDefaultBrokerPageStore } from 'store/pages/enrollment/broker/broker-default/pageStore';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import { SelectAgentForm } from 'components/common/enrollment/pick-producer/SelectAgentForm';
import DDARAuthorizedAgents from 'components/common/form/custom/carrier-components/DDAR/AuthorizedAgents';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const {
    getInitialData,
    producerDetailsForm,
    onBackRedirect,
    canCompleteStep,
    onComplete,
    selectProducerDelegate,
    ddarAuthorizedAgentsDelegate,
    ddarAdditionalContactsInformationDelegate,
  } = useDefaultBrokerPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  const supportedCustomComponents = useMemo(() => {
    return {
      ddarAuthorizedAgents: (
        <DDARAuthorizedAgents
          key="ddarAuthorizedAgents"
          delegate={ddarAuthorizedAgentsDelegate?.replicatedInfoDelegate ?? null}
        />
      ),
    };
  }, [ddarAuthorizedAgentsDelegate, ddarAdditionalContactsInformationDelegate]);

  return (
    <>
      <PageHeader
        title={CARD_DATA.DEFAULT_BROKER.title}
        subtitle={CARD_DATA.DEFAULT_BROKER.text}
        onBackButtonClick={onBackRedirect}
      />
      <SelectAgentForm selectProducerDelegate={selectProducerDelegate} />
      {selectProducerDelegate.selectedProducer || selectProducerDelegate.producerNotFound ? (
        <DynamicForm
          formDelegate={producerDetailsForm}
          showFooter={false}
          customComponents={supportedCustomComponents}
        />
      ) : null}
      <PageFooter onBack={onBackRedirect} onComplete={onComplete} disableCompleteButton={!canCompleteStep} />
    </>
  );
});

export default PageContent;
